<template>
	<div class="hello" id="box" v-if="type">
		<!-- 顶部 -->
		<div class="title">
			<div>
				<img @mouseover="changeMask(true,'a')" @mouseout="changeMask(false,'a')" :id="'abc'+('a')" class="title_stylea" @click="homePage" src="../assets/left.png">
				<img class="title_style" src="../assets/logo.png">
			</div>
		</div>

		
		<div class="nvarchar">
			<div class="nvarchar_item">
				<div style="color: #333333;">{{lista.d}} {{lista.m}} </div>
				<div>{{lista.y}}</div>
			</div>
			<div v-html="lista.content" class="analysis"></div>
		</div>

		<div class="bottom">备案信息：浙ICP备2021028688号-2</div>
	</div>
</template>

<script>
	export default {
		name: 'HelloWorld',
		data() {
			return {
				type:true,
				id: "",
				list: [],
				lista:{
					content:"",
					y:'2021',
					d:'04',
					m:'ASD'
				},
				backtrack:''
			}
		},
		created() {
			this.id = this.$route.query.id
			this.backtrack = this.$route.query.type
			this.drawing()
			this.journalism()
		},
		methods: {
			changeMask:function(b,index){
			    if(b){
			       	document.getElementById("abc"+index).style.cursor="pointer"; 
			    }else{
			        document.getElementById("abc"+index).style.cursor="wait"; 
				}
			},
			journalism(){
					  this.$axios.request({
					  	method: "get",
					  	url: 'http://www.leadbio.com/api/articles/index',
					  	params:{
					  		page:1,
					  		limit:3
					  	}
					  }).then((res)=> {
					  	this.list=res.data.data.data
					  })
			},
			drawing() {
				this.$axios.request({
					method: "get",
					url: 'http://www.leadbio.com/api/articles/details',
					params: {
						id: this.id
					}
				}).then((res) => {
					this.lista = res.data.data
				})
			},
			know(id){
				this.id=id
				this.drawing()
				this.type=false
				this.type=true
			},
			//返回首页
			homePage() {
				if(this.backtrack){
					this.$router.go(-1)
				}else{
					this.$router.push({
						path: '/',
					})
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.hello{
		width: 1400px;;
	}
	.nvarchar{
		margin-top: 100px;
		display: flex;
	}
	.nvarchar_item{
		margin: 0 50px 0 120px;
		font-size: 36px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 45px;
	}
	.analysis{
		width: 60%;
		max-width: 60%;
		word-wrap: break-word;
		table-layout: fixed;
		word-break: break-all;
		white-space: pre-wrap;
	}
	.even_more {
		margin-top: 100px;
		margin-left: 7%;
		margin-bottom: 60px;
		font-size: 36px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 45px;
	}

	.even_more span {
		color: #C63530;
	}

	.learn_more {
		text-align: center;
		font-size: 17px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
		line-height: 20px;
		letter-spacing: 3px;
		padding: 10px 40px;
		background: #C63530;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		width: 12%;
		margin-left: 44%;
		margin-bottom: 100px;
	}

	.part_five {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.journalism {
		width: 86%;
		display: flex;
		/* justify-content: space-between; */
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
	}

	.journalism_div{
		width: 30%;
		height: 175px;
		margin-left: 3%;
		margin-bottom: 30px;
		position: relative;
	}
	.journalism_time{
		border-left: 3px solid #C63530;
		padding-left: 10px;
		font-size: 16px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 16px;
		margin-bottom: 30px;
		
	}
	.journalism_text{
		font-size: 18px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #333333;
		line-height: 32px;
		margin-bottom: 30px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
	.journalism_more{
		position: absolute;
		bottom: 0;
		font-size: 15px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 27px;
	}

	.title {
		position: fixed;
		top: 0;
		width: 100%;
		height: 66px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.11999999731779099);
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}

	.title div {
		height: 66px;
		display: flex;
		align-items: center;
		margin-left: 50px;
	}

	.title_navigation {
		width: 48px;
		height: 48px;
	}

	.title_style {
		width: 150px;
		margin-left: 20px;
	}
	.title_stylea{
		width: 48px;
		height: 48px;
	}

	.part_one {
		width: 100%;
		display: flex;
		align-items: center;
		padding-top: 163px;
	}

	.part_one_module {
		height: 434px;
		width: 42%;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}

	.part_one_module_title {
		font-size: 75px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 75px;
		margin: 0 0 10px 64px;
	}

	.part_one_module_scroll {
		padding: 6px 16px 6px 64px;
		background: #C53631;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		font-size: 74px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #FFFFFF;
		line-height: 74px;
		margin-bottom: 10px;
	}

	.part_one_module_drawing {
		font-size: 32px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 38px;
		margin: 0 0 10px 64px;
	}

	.part_one_module_text {
		font-size: 16px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #333333;
		margin: 0 0 10px 64px;
	}

	.part_tow_module {
		margin-left: 28px;
		width: 50%;
		text-align: center;
	}

	.part_tow_module img {
		width: 400px;
		height: 400px;
	}

	.part_tow_img {
		width: 100%;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.part_tow_img img {
		width: 30%;
		height: 116px;
	}

	.part_two {
		width: 82%;
		margin-top: 90px;
		padding: 40px 120px;
		display: flex;
	}

	.part_two_one {
		width: 55%;
	}

	.part_two_one_title {
		font-size: 60px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 60px;
		margin-bottom: 20px;
	}

	.part_two_one_title span {
		color: #C63530;
	}

	.part_two_one_symbol {
		font-size: 60px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 60px;
	}

	.part_two_one_symbol_finally {
		font-size: 60px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 60px;
		margin-left: 100%;
	}

	.part_two_one_essay {
		padding: 40px;
		background: #F4F4F4;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		font-size: 30px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #333333;
	}

	.part_two_one_essay_one {
		width: 90%;
		font-size: 17px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 33px;
		margin: 30px 0;
	}

	.part_two_one_essay_img {
		width: 71%;
		height: 257px;
		margin-top: 30px;
	}

	.part_two_tow {
		width: 45%;
		padding-left: 56px;
	}

	.part_two_tow img {
		width: 100%;
		height: 206px;
		margin-bottom: 30px;
	}

	.part_two_tow div {
		text-align: center;
		font-size: 46px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #838383;
		line-height: 46px;
	}

	.part_three {
		margin: 30px 0;
		text-align: center;
		width: 100%;
	}

	.part_three div {
		font-size: 56px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 56px;
	}

	.part_three div span {
		font-size: 56px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 56px;
	}

	.part_three img {
		width: 86%;
		height: 747px;
		margin-top: 30px;
	}

	.part_four {
		display: flex;
		align-items:center;
		justify-content: center;
		margin-bottom: 30px;
		text-align: center;
		width: 100%;
		height: 458px;
	}

	.part_four div {
		font-size: 60px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
		line-height: 60px;
	}

	.part_six {
		margin-top: 30px;
		display: flex;
		align-items: center;
		width: 100%;
		height: 575px;
		background: #BBB7B7;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}

	.part_six_message {
		width: 54%;
		height: 404px;
		background: rgba(255, 255, 255, 0.5);
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}

	.part_six_message_title {
		margin: 46px 0 70px 100px;
		font-size: 56px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 56px;
	}

	.part_six_message_title span {
		color: #C63530;
	}

	.part_six_message_text {
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 22px;
		margin: 0 0 10px 100px;
	}

	.bottom {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 38px;
			background: #C63530;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}
</style>



// WEBPACK FOOTER //
// src/components/details.vue